import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import 'flag-icons/css/flag-icons.min.css'
import './App.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
